// loading.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject, delay } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private isLoadingSubject = new BehaviorSubject<boolean>(true);
  public isLoading$ = this.isLoadingSubject.asObservable().pipe(
    delay(0)
  );

  private isLoadSubject = new BehaviorSubject<boolean>(true);
  public isLoad$ = this.isLoadSubject.asObservable().pipe(
    delay(0)
  );

  show() {
    this.isLoadingSubject.next(true);
  }

  hide() {
    this.isLoadingSubject.next(false);
  }

  showLoad() {
    this.isLoadSubject.next(true);
  }

  hideLoad() {
    this.isLoadSubject.next(false);
  }

  get currentValue(): boolean {
    return this.isLoadingSubject.value;
  }

  get currentValueLoad(): boolean {
    return this.isLoadSubject.value;
  }
}